var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mensageria-module"},[_c('p',{staticClass:"mb-3"},[_vm._v("\n    Painel administrativo de Mensageria (estatísticas e modelos da\n    plataforma).\n  ")]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":"/mensageria/admin"}},[_vm._v("\n    Abrir painel Mensageria\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }